import { FC } from 'react';
import { ReqStatusBadge } from './ReqStatusBadge';

export const StatusRenderReqCell: FC<{value: string;}> = (props) => {
  const { value } = props;
  return (
    <ReqStatusBadge status={value} />
  );
};
